import { render, staticRenderFns } from "./SupplierByCompany.vue?vue&type=template&id=6ecddd1e"
import script from "./SupplierByCompany.vue?vue&type=script&lang=js"
export * from "./SupplierByCompany.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports